interface SectionHeaderFieldProps {
  title: string;
  description?: string;
}

// Display-only content — no answer to collect, so no onChange/error.
const SectionHeaderField = ({ title, description }: SectionHeaderFieldProps) => (
  <div className="border-t border-uniform-gray-200 pt-4 first:border-t-0 first:pt-0 dark:border-uniform-gray-700">
    <h3 className="text-base font-semibold text-uniform-gray-900 dark:text-uniform-gray-100">
      {title}
    </h3>
    {description && (
      <p className="text-sm text-uniform-gray-600 dark:text-uniform-gray-400">{description}</p>
    )}
  </div>
);

export default SectionHeaderField;
